import { gql } from '@apollo/client'
import { PAGINATION_FRAGMENT } from '../Fragments'

export const LEGAL_FORMALITIES_INDEX_FRAGMENT = gql`
  fragment LegalFormalitiesIndexFragment on LegalFormalitiesIndex {
    id
    legalFormalityStatus
    domiciliationId
    purchaseId
    contactId
    countryCode
    purchaseStatus
    purchaseType
    productIdentificationToken
    firstname
    lastname
    societyName
    email
    createdAt
    assignedUserEmail
    formProvider
  }
`

export const LEGAL_FORMALITIES_INDEX_PAGINATED_FRAGMENT = gql`
  fragment LegalFormalitiesIndexPaginatedFragment on LegalFormalitiesIndexPaginated {
    pagination {
      ...PaginationFragment
    }
    legalFormalities {
      ...LegalFormalitiesIndexFragment
    }
  }
  ${LEGAL_FORMALITIES_INDEX_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export const LEGAL_FORMALITIES_INDEX_QUERY = gql`
  query LegalFormalitiesIndexPage(
    $pagination: PaginationInput!
    $sorter: SorterInput
    $filters: [FilterInput!]
    $search: SearchInput
  ) {
    legalFormalitiesIndexPage(
      pagination: $pagination
      sorter: $sorter
      filters: $filters
      search: $search
    ) {
      ...LegalFormalitiesIndexPaginatedFragment
    }
  }
  ${LEGAL_FORMALITIES_INDEX_PAGINATED_FRAGMENT}
`
